/*
  Hempstore Naturals – gemeinsame Logik für die CBD-Öl-Mengenstaffel
  ---------------------------------------------------------------------------
  Wird von Produktseite (snippets/hs-quantity-cards.liquid) und Collection
  (snippets/hs-oil-card-quantity.liquid) gemeinsam genutzt.

  Enthält ausschließlich Anzeigelogik. Die Rabatte selbst liegen unverändert
  in den automatischen Shopify-Rabatten:
    ab 2 CBD-Öl-Flaschen 5 %, ab 3 = 8 %, ab 4 = 10 %,
    alle vier Konzentrationen zählen gemeinsam.

  Rundung exakt wie Shopify:
    Stückpreis in Cent = round(Listenpreis * (100 - Rabatt) / 100)
    erst danach Multiplikation mit der Menge.
*/
(function () {
  if (window.HSOil) return;

  /* Geldformat der von uns gerenderten Beträge:
       'after' -> 39,90 €   (Vorgabe, passt zur bestehenden €/ml-Zeile)
       'shop'  -> Shop-Einstellung, aktuell €39,90
     Eine Zeile ändern genügt. */
  var MONEY_STYLE = 'after';

  var TIERS = [
    { min: 4, rate: 10 },
    { min: 3, rate: 8 },
    { min: 2, rate: 5 }
  ];

  var config = null;
  var oilIds = [];
  var oilCount = 0;
  var listeners = [];
  var started = false;

  function getConfig() {
    if (config) return config;
    var el = document.querySelector('[data-hs-oil-config]');
    if (!el) return null;
    try {
      config = JSON.parse(el.textContent);
    } catch (e) {
      config = null;
    }
    if (config) oilIds = (config.oilProductIds || []).map(Number);
    return config;
  }

  function rateFor(totalBottles) {
    for (var i = 0; i < TIERS.length; i++) {
      if (totalBottles >= TIERS[i].min) return TIERS[i].rate;
    }
    return 0;
  }

  /* Rabattierter Stückpreis in Cent. */
  function unitCents(priceCents, rate) {
    if (!rate) return priceCents;
    return Math.round((priceCents * (100 - rate)) / 100);
  }

  /* Preis je ml (Cent), aus dem bereits rabattierten Stückpreis. */
  function perUnitCents(unit, volume) {
    if (!volume) return 0;
    return Math.round(unit / volume);
  }

  /*
    Gesetzlicher Grundpreis (Cent) aus dem rabattierten Stückpreis.
    Der Umrechnungsfaktor wird aus den unrabattierten Serverwerten abgeleitet
    (unitPriceCents / priceCents), damit keine Einheitentabelle nötig ist.
    Geprüft gegen Shopify: 3591 * (399000 / 3990) = 359100 = 3.591,00 €/l.
  */
  function referenceCents(unit, priceCents, referencePriceCents) {
    if (!priceCents || !referencePriceCents) return 0;
    return Math.round((unit * referencePriceCents) / priceCents);
  }

  function money(cents) {
    var cfg = getConfig() || {};
    var useComma = cfg.moneyComma !== false;
    var value = (Math.round(cents) / 100).toFixed(2);
    var parts = value.split('.');
    var thousandsSep = useComma ? '.' : ',';
    var decimalSep = useComma ? ',' : '.';
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    var number = whole + decimalSep + parts[1];

    if (MONEY_STYLE === 'shop') {
      return (cfg.moneyPrefix || '') + number + (cfg.moneySuffix || '');
    }
    return number + ' ' + (cfg.currencySymbol || '€');
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  /*
    Ruft alle angemeldeten Komponenten.
    Gibt eine Komponente ausdrücklich false zurück, ist ihr Element aus dem DOM
    verschwunden (z. B. nachdem Shopify das Produktraster neu gerendert hat) –
    sie wird dann abgemeldet, damit die Liste beim Filtern nicht mitwächst.
  */
  function emit() {
    listeners = listeners.filter(function (fn) {
      try {
        return fn(oilCount) !== false;
      } catch (e) {
        return true;
      }
    });
  }

  function refresh() {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        oilCount = (cart.items || []).reduce(function (sum, item) {
          return oilIds.indexOf(Number(item.product_id)) > -1 ? sum + item.quantity : sum;
        }, 0);
        emit();
        return oilCount;
      })
      .catch(function () {
        emit();
        return oilCount;
      });
  }

  /* Komponenten melden sich hier an und werden bei jeder Warenkorbänderung gerufen. */
  function register(fn) {
    listeners.push(fn);
    try {
      fn(oilCount);
    } catch (e) {}
  }

  function start() {
    if (started) return;
    started = true;
    getConfig();

    var cartEvent = (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update';

    if (typeof window.subscribe === 'function') {
      window.subscribe(cartEvent, refresh);
    } else {
      document.addEventListener(cartEvent, refresh);
      window.addEventListener('focus', refresh);
    }

    // Zurück-/Vorwärts-Navigation (bfcache)
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refresh();
    });

    refresh();
  }

  window.HSOil = {
    rateFor: rateFor,
    unitCents: unitCents,
    perUnitCents: perUnitCents,
    referenceCents: referenceCents,
    money: money,
    register: register,
    refresh: refresh,
    start: start,
    count: function () {
      return oilCount;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
